<div mat-dialog-title class="dialog-info horizontal-padding m-0">
	<span class="dialogTitle">
		{{'JOB_DETAILS' | translate}}
	</span>
	<button type="button" class="btn-close btn-close-white shadow-none dialogCross" mat-dialog-close></button>
</div>

<mat-dialog-content class="horizontal-padding overflow-hidden">
	<fieldset>
		<legend>{{ 'JOB_DETAILS' | translate }}</legend>
		<div [formGroup]="jobDetailsForm" trackChanges>
			<!-- Product Offering -->
			<div class="row align-items-center">
				<div class="col-sm-4">{{ 'PRODUCT_OFFERING' | translate }}</div>
				<div class="col-sm-8 ps-0 d-flex gap-2">
				@for (option of productOfferingOptions; track option.controlName) {
				<mat-checkbox color="primary" [formControlName]="option.controlName">
					{{ option.label | translate }}
				</mat-checkbox>
				}
				</div>
			</div>
			<!-- Installation Type -->
			<div class="row align-items-center mb-3">
				<div class="col-sm-4">
					<label for="installationType">{{ 'INSTALLATION_TYPE' | translate }}</label>
				</div>
				<div class="col-sm-5">
					<mat-form-field appearance="outline" class="m-0 col-sm-8">
						<mat-select id="installationType" formControlName="installationType">
							@for (option of installationTypeOptions; track option) {
							<mat-option [value]="option">{{ option }}</mat-option>
							}
						</mat-select>					
					</mat-form-field>
				</div>
			</div>
			<!-- Size Site -->
			<div class="row align-items-baseline">
				<div class="col-sm-4">
					<label for="siteSize">{{ 'SITE_SIZE_SQUARE_FOOTAGE' | translate }}</label>
				</div>
				<div class="col-sm-5">
					<mat-form-field appearance="outline" class="m-0 col-sm-8">
						<input matInput id="siteSize" [appNumericMask] = "numericFieldsConfig" class="text-end" formControlName="siteSize">
					</mat-form-field>
				</div>
			</div>

			<!-- Antenna Qty -->
			<div class="row align-items-baseline">
				<div class="col-sm-4">
					<label for="antennaQty">{{ 'ANTENNA_QTY' | translate }}</label>
				</div>
				<div class="col-sm-5">
					<mat-form-field appearance="outline" class="m-0 col-sm-8">
						<input matInput id="antennaQty" [appNumericMask] = "numericFieldsConfig" class="text-end" formControlName="antennaQty">
					</mat-form-field>
				</div>
			</div>

			<!-- Agent Weight -->
			<div class="row align-items-baseline">
				<div class="col-sm-4">
					<label for="agentWeight">{{ 'AGENT_WEIGHT' | translate }}</label>
				</div>
				<div class="col-sm-5 d-flex align-items-baseline gap-2">
					<mat-form-field appearance="outline" class="m-0 col-sm-8">
						<input matInput id="agentWeight" [appNumericMask] = "numericFieldsConfig" class="text-end" formControlName="agentWeight">
					</mat-form-field>
					<span> {{ 'LBS.' | translate }}</span>
				</div>
			</div>

			<!-- Clean Agent Net Vol Space -->
			<div class="row align-items-baseline">
				<div class="col-sm-4">
					<label for="cleanAgentVol">{{ 'CLEAN_AGENT_NET_VOL_SPACE' | translate }}</label>
				</div>
				<div class="col-sm-5 d-flex align-items-baseline gap-2">
					<mat-form-field appearance="outline" class="m-0 col-sm-8">
						<input matInput id="cleanAgentVol" [appNumericMask] = "numericFieldsConfig" class="text-end" formControlName="cleanAgentNetVolSpace">
					</mat-form-field>
					<span> {{ 'CUBIC_FEET' | translate }}</span>
				</div>
			</div>
		</div>
	</fieldset>
</mat-dialog-content>

<mat-dialog-actions align="end" class="dialog-actions-style horizontal-padding">
	<button mat-raised-button color="primary" (click)="onOkay()" [disabled]="!jobDetailsForm.valid">
		{{'OK_BTN_LABEL' | translate}}
	</button>

	<button mat-raised-button color="warn" class="button-padding" mat-dialog-close>
		{{'CANCEL_BTN_LABEL' | translate}}
	</button>
</mat-dialog-actions>
